import { render, staticRenderFns } from "./behaviour-page.vue?vue&type=template&id=c73bb364"
import script from "./behaviour-page.vue?vue&type=script&lang=js"
export * from "./behaviour-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports